export default {
    bind: (el) => {
        el.classList.add('opacity-animation');

        setTimeout(() => {
            el.classList.add('visible');
        }, 0);
    },
};
